import { createContext } from "react";

interface ITableContext {
  onGenerateCurrentState: () => void;
  toggleAllStats: boolean;
}

export const TableContext = createContext<ITableContext>({
  onGenerateCurrentState: () => {},
  toggleAllStats: false,
});